<script>
    import Items from "./Items.js";
    import QandA from "./QandA.svelte";
</script>

<div class="title">El Catecismo de Heidelberg</div>

<div class="block">
    {#each Items as { number, question, answer, proofs }}
    <QandA
        number="{number}"
        question="{question}"
        answer="{answer}"
        proofs="{proofs}"
    />
    {/each}
</div>

<style>
    .section {
        padding: 4rem 3rem;
    }
</style>
